/**
 * Der vom User gewählte Vorschlag.
 * isAutoSelected ist true, wenn keinen Vorschlag direkt gewählt, sondern im Eingabefeld einfach Enter gedrückt wurde.
 */
export class SelectedSuggestion {
  constructor(
    public input: string,
    public value: any,
    public isAutoSelected: boolean,
    public extra?: any
  ) {}
}

/**
 * Ein Typeahead-Vorschlag.
 * Die cssClass bezieht sich auf das class des A-Tags innerhalb des LI.
 * Damit können für die Vorschläge Icons eingebunden werden (z.B.: cssClass: 'now-icon now-icon-info').
 * isReadOnly bedeutet, dass der Vorschlag nicht ausgewählt werden können soll (z.B. für Error-Texten).
 */
export class Suggestion {
  private constructor(
    public label: string,
    public value: any,
    public cssClass?: string,
    public isReadOnly?: boolean,
    public extra?: any
  ) {}

  // Erzeugt einen (auswählbaren) Vorschlag
  static of(label: string, value: any, cssClass?: string, extra?: any, isReadOnly?: boolean) {
    return new Suggestion(label, value, cssClass, isReadOnly ?? false, extra);
  }

  // Erzeugt einen (nicht-auswählbaren) Info-'Vorschlag'
  static info(label: string) {
    return new Suggestion(label, null, 'info now-link-icon now-icon-info', true);
  }

  // Erzeugt einen (nicht-auswählbaren) Error-'Vorschlag'
  static error(label: string) {
    return new Suggestion(label, null, 'error now-link-icon now-icon-warning', true);
  }
}
